<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
        title="Eigenschappen"
        :icon="summaryIcon"
        :large="true"
    >
      <dean-notification :is-modal="true">

      </dean-notification>
      <dean-table
          :data='data'
          :columns='columns'
      >

      </dean-table>
      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Sluiten</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import {
    // SVG
    warningIcon,
    // COMPONENTS
    deanDialog,
    summeryIcon,
    deanTable,
  } from '@deanone/dean-components';
  import deanButton from '@/components/deanComponents/deanButton.vue';
  import DeanNotification from '@/components/deanComponents/deanNotification.vue';
  import {deanDialogBus} from '@/main';
  import {CollapseTransition} from 'vue2-transitions';

  @Component({
    components: {
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      CollapseTransition,
      deanTable,
    },
  })

  export default class ServiceProperties extends Vue {
    // DATA
    @Prop() public payloadData!: {
      [key: string]: any,
    };
    public data: any = [];
    public summaryIcon: any = summeryIcon;

    get columns() {
      return {
        name: {
          content: 'Naam eigenschap',
          align: 'left',
        },
        value: {
          content: 'Waarde',
          align: 'left',
        },
      };
    }

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public created() {
      const data = this.payloadData.properties;
      for (const property of Object.keys(data)) {
        this.data.push({
          name: property,
          value: data[property],
        });
      }
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }

  .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
  {
    opacity: 0;
    transform: translateY(30px);
  }
</style>
